const SendersSmsCreate = () => import('./pages/SendersSmsCreate.vue')
const SendersSmsList = () => import('./pages/SendersSmsList.vue')
const SendersDomainCreate = () => import('./pages/SendersDomainCreate.vue')
const SendersDomainList = () => import('./pages/SendersDomainList.vue')

const sendersRoutes = [
  {
    path: 'senders/sms',
    name: 'senders-sms',
    component: SendersSmsList,
    meta: { requiresAuth: true, menuType: 'senders' },
  },
  {
    path: 'senders/sms/new',
    name: 'new-senders-sms',
    component: SendersSmsCreate,
    meta: { requiresAuth: true, menuType: 'senders' },
  },
  {
    path: 'senders/domain',
    name: 'senders-domain',
    component: SendersDomainList,
    meta: { requiresAuth: true, menuType: 'senders' },
  },
  {
    path: 'senders/domain/new',
    name: 'new-senders-domain',
    component: SendersDomainCreate,
    meta: { requiresAuth: true, menuType: 'senders' },
  }
]


export default sendersRoutes;
